import { Helmet } from "react-helmet-async"
import StartYourFreeTrial from "../../components/StartYourFreeTrial"

const demos = [
  {
    title: "Download Ministry Member Information",
    video: "czeq1MaQIwI",
  },
  {
    title: "Mobile App Overview",
    video: "mn7aTHsCdTE",
  },
  {
    title: "Create an Admin Account",
    video: "maqObnwLYpY",
  },
  {
    title: "Edit Church Information",
    video: "K0SkbsTO3P4",
  },
  {
    title: "Add a Ministry",
    video: "EPhzo9JAuWo",
  },
  {
    title: "Add a Family",
    video: "fmp47QNAQM0",
  },
  {
    title: "Add a Member",
    video: "1RWptGHNv4Y",
  },
  {
    title: "Add Leadership Team",
    video: "ygBQVHbgeLY",
  },
  {
    title: "Add Leadership",
    video: "TnP5UAkxCHU",
  },
  {
    title: "Add a Schedule",
    video: "JxO85s91WVE",
  },
  {
    title: "Clone a Schedule",
    video: "Bq_Ui11NRCs",
  },
  {
    title: "Add an Event",
    video: "ZW62825HaMI",
  },
  {
    title: "Create a Notification",
    video: "okJDqfdwZw0",
  },
  {
    title: "Notification Logs",
    video: "GeWbvxKJZnk",
  },
  {
    title: "Manage Login Devices",
    video: "IzHem6cxkh4",
  },
  {
    title: "Create Support Ticket",
    video: "kFsuvB5QohM",
  },
];

const Demos = () => {
  return (
    <>
      <Helmet>
        <title>My Church Directory Demos | Online Church Directory Software</title>

        <meta
          name="description"
          content="Explore powerful church directory features including member management, mobile apps, email and text messaging, printable directories, and secure online access. Manage your church directory with ease."
        />
      </Helmet>

      <section className="bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-4 py-1 text-sm font-medium">
              Product Demos
            </span>

            <h1 className="different_heading mt-5 text-4xl lg:text-5xl font-bold text-slate-900">
              Learn My Church Directory in Minutes
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-8">
              Explore step-by-step video tutorials covering member management,
              ministries, events, notifications, leadership, and more.
            </p>
          </div>

          <div>
            <img
              src="../images/demo-hero-img.png"
              alt="My Church Directory Demo"
              className="rounded-3xl shadow-xl w-full"
            />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-14">
            <h2 className="different_heading text-3xl font-bold">
              Video Tutorials
            </h2>

            <p className="mt-3 text-slate-600">
              Everything you need to get started with My Church Directory.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">

            {demos.map((demo) => (
              <div
                key={demo.video}
                className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-lg transition"
              >
                <iframe
                  className="w-full aspect-video"
                  src={`https://www.youtube.com/embed/${demo.video}`}
                  title={demo.title}
                  allowFullScreen
                />

                <div className="p-5">
                  <h3 className="font-semibold text-lg">
                    {demo.title}
                  </h3>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      <StartYourFreeTrial />

    </>
  )
}

export default Demos